import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import type IFormInputs from "./IFormInputs";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import Email from "src/shared/forms/validations/Email";
import { length as Length } from "src/shared/forms/validations/Length";
import { required as Required } from "src/shared/forms/validations/Required";

export interface IEmailProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {
  isRequired?: boolean;
  minLength?: number;
  maxLength?: number;
}

export default (props: IEmailProps) => {
  const {
    inputID,
    label = <FormattedMessage id="form.email" />,
    validationDisabled = false,
    isRequired = true,
    minLength,
    maxLength,
    ...rest
  } = props;

  const validations = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }

    const validations = [];

    validations.push(Email);

    if (isRequired) {
      validations.push(Required);
    }
    if (minLength || maxLength) {
      validations.push(Length(minLength, maxLength));
    }

    return validations;
  }, [validationDisabled, isRequired, minLength, maxLength]);

  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={validations}
      {...rest}
    />
  );
};
